import { canonicalVotePath } from '../../discovery'

/**
 * Update the URL to the canonical vote path without triggering a navigation
 * (mirrors Rust's set_vote_hash). Falls back to setting href if not on /proyecto/.
 */
export function setVoteHash(slug: string, boletin: string): void {
  if (typeof window === 'undefined') return
  const target = canonicalVotePath(boletin, slug)
  const pathname = window.location.pathname
  if (pathname.startsWith('/proyecto/')) {
    window.history.replaceState(null, '', target)
  } else {
    window.location.href = target
  }
}

/**
 * Scroll an element into view unconditionally with smooth behavior and center
 * block alignment.
 */
export function scrollToElementSmooth(id: string): void {
  if (typeof document === 'undefined') return
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

/**
 * Scroll an element into view (plain, no offset check).
 * Mirrors Rust's scroll_to_element.
 */
export function scrollToElement(id: string): void {
  if (typeof document === 'undefined') return
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView()
  }
}

/**
 * Scroll an element into view only if it is outside the visible viewport.
 * Mirrors Rust's scroll_if_offscreen.
 */
export function scrollIfOffscreen(id: string): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  const el = document.getElementById(id)
  if (!el) return
  const rect = el.getBoundingClientRect()
  const viewportHeight = window.innerHeight ?? 800
  if (rect.top > viewportHeight || rect.top < 0) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}
